(() => {
  const normalize = (value = '') => String(value)
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const root = (() => {
    const value = window.Shopify?.routes?.root || '/';
    return value.endsWith('/') ? value : `${value}/`;
  })();

  const localeUrl = (path) => `${root}${String(path).replace(/^\/+/, '')}`;

  const coreTcgLinks = [
    { key: 'pokemon', title: 'Pokémon', path: 'collections/pokemon' },
    { key: 'one-piece', title: 'One Piece', path: 'collections/one-piece' },
    { key: 'magic-the-gathering', title: 'Magic: The Gathering', path: 'collections/magic-the-gathering' },
  ];

  const coreTitleKeys = new Set(coreTcgLinks.map((item) => normalize(item.title)));
  const isTcgMenuTitle = (value = '') => [
    'tcg-s', 'tcgs', 'alle-tcg-s', 'alle-tcgs', 'all-tcgs'
  ].includes(normalize(value));

  const setCoreHref = (anchor, item) => {
    if (!(anchor instanceof HTMLAnchorElement)) return;
    anchor.href = localeUrl(item.path);
  };

  const createDesktopWrapper = (item) => {
    const wrapper = document.createElement('div');
    wrapper.dataset.kwebbeltcgCoreLink = item.key;

    const anchor = document.createElement('a');
    anchor.className = 'mega-menu__link';
    setCoreHref(anchor, item);

    const label = document.createElement('span');
    label.className = 'wrap-text';
    label.textContent = item.title;

    anchor.append(label);
    wrapper.append(anchor);
    return wrapper;
  };

  const createMobileItem = (item) => {
    const li = document.createElement('li');
    li.className = 'menu-drawer__list-item';
    li.dataset.kwebbeltcgCoreLink = item.key;

    const anchor = document.createElement('a');
    anchor.className = 'menu-drawer__menu-item menu-drawer__menu-item--child focus-inset';
    setCoreHref(anchor, item);

    const label = document.createElement('span');
    label.className = 'menu-drawer__menu-item-text wrap-text';
    label.textContent = item.title;

    anchor.append(label);
    li.append(anchor);
    return li;
  };

  const orderDesktopMenu = (menuItem) => {
    const list = menuItem.querySelector(':scope > .menu-list__submenu .mega-menu__list');
    if (!list) return;

    let columns = Array.from(list.children).filter((child) => child.classList?.contains('mega-menu__column'));
    let targetColumn = columns[0];

    if (!targetColumn) {
      targetColumn = document.createElement('li');
      targetColumn.className = 'mega-menu__column mega-menu__column--span-1';
      list.prepend(targetColumn);
      columns = [targetColumn];
    }

    const allWrappers = columns.flatMap((column) =>
      Array.from(column.children).filter((child) => child.tagName === 'DIV')
    );

    const coreWrappers = new Map();
    const remainingWrappers = [];

    allWrappers.forEach((wrapper) => {
      const anchor = wrapper.querySelector(':scope > a.mega-menu__link');
      const titleKey = normalize(anchor?.textContent || '');
      const coreItem = coreTcgLinks.find((item) => normalize(item.title) === titleKey);

      if (coreItem && !coreWrappers.has(coreItem.key)) {
        coreWrappers.set(coreItem.key, wrapper);
        setCoreHref(anchor, coreItem);
      } else if (!coreTitleKeys.has(titleKey)) {
        remainingWrappers.push(wrapper);
      }
    });

    coreTcgLinks.forEach((item) => {
      if (!coreWrappers.has(item.key)) coreWrappers.set(item.key, createDesktopWrapper(item));
    });

    const desiredWrappers = [
      ...coreTcgLinks.map((item) => coreWrappers.get(item.key)),
      ...remainingWrappers,
    ];

    desiredWrappers.forEach((wrapper, index) => {
      const current = targetColumn.children[index];
      if (current !== wrapper) targetColumn.insertBefore(wrapper, current || null);
    });

    targetColumn.className = 'mega-menu__column mega-menu__column--span-1';
    columns.forEach((column) => {
      if (column !== targetColumn) column.remove();
    });
  };

  const orderMobileMenu = (menuItem) => {
    const list = menuItem.querySelector('ul.menu-drawer__menu--childlist');
    if (!list) return;

    const allItems = Array.from(list.children).filter((child) => child.tagName === 'LI');
    const coreItems = new Map();
    const remainingItems = [];

    allItems.forEach((li) => {
      const anchor = li.querySelector(':scope > a');
      const titleKey = normalize(anchor?.textContent || '');
      const coreItem = coreTcgLinks.find((item) => normalize(item.title) === titleKey);

      if (coreItem && !coreItems.has(coreItem.key)) {
        coreItems.set(coreItem.key, li);
        setCoreHref(anchor, coreItem);
      } else if (!coreTitleKeys.has(titleKey)) {
        remainingItems.push(li);
      }
    });

    coreTcgLinks.forEach((item) => {
      if (!coreItems.has(item.key)) coreItems.set(item.key, createMobileItem(item));
    });

    const desiredItems = [
      ...coreTcgLinks.map((item) => coreItems.get(item.key)),
      ...remainingItems,
    ];

    desiredItems.forEach((li, index) => {
      const current = list.children[index];
      if (current !== li) list.insertBefore(li, current || null);
    });
  };

  const ensureCoreTcgMenuLinks = () => {
    document.querySelectorAll('.header-menu .menu-list__list-item').forEach((menuItem) => {
      const topLink = menuItem.querySelector(':scope > a.menu-list__link');
      if (topLink && isTcgMenuTitle(topLink.textContent)) orderDesktopMenu(menuItem);
    });

    document.querySelectorAll('.menu-drawer__menu > .menu-drawer__list-item, .menu-drawer__menu > li').forEach((menuItem) => {
      const topControl = menuItem.querySelector(':scope > a, :scope > details > summary');
      if (topControl && isTcgMenuTitle(topControl.textContent)) orderMobileMenu(menuItem);
    });
  };

  ensureCoreTcgMenuLinks();

  new MutationObserver(() => ensureCoreTcgMenuLinks())
    .observe(document.documentElement, { childList: true, subtree: true });
})();
